import { createAxios, createAxiosLogistica } from "./axiosHttpMarconi";
export const serviciosService = {
  getServicios,
  getServiciosByCliente,
  getServiciosLogisticaByCliente,
};

function getServicios(tipoServicio) {
  const axios = createAxios();
  // const tipo = localStorage.getItem('tipo');
  let urlPath = `servicio?sort=_id&order=ascending`;
  if (tipoServicio && tipoServicio != "") {
    urlPath += `&tipo=${tipoServicio}`;
  }
  return axios.get(urlPath);
}
function getServiciosByCliente(request) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  const request_id = request?.id || user.extraData.clienteId;

  let urlPath = `/servicio/cliente/${request_id}`;
  if (request?.tipo && request.tipo != "") {
    urlPath += `?tipo=${request.tipo}`;
  }
  if (request?.rma && request.rma != "") {
    urlPath += `&rma=${request.rma}`;
  }
  return axios.get(urlPath);
}

function getServiciosLogisticaByCliente() {
  const axios = createAxiosLogistica();
  const user = JSON.parse(localStorage.getItem("user"));
  const clienteId = user.extraData.clienteId;

  return axios.get(`/logistica/cliente/${clienteId}/servicios`);
}
